module.exports = __webpack_public_path__ + "media/fonts/Quicksand-Bold-76f20c55b4aa564ea883173598963b95.ttf";